var template = require('../js/template')

function addTooltip(el, contentElement) {
  var tip;
  // try /catch IE 11 support
  try {
    tip = el.dataset.tooltip;
  } catch (error) {
    tip = el.getAttribute('data-tooltip');
  }
  // Create instance of template
  var tooltipTemplate = template.populate(tip)
  var content = getTooltipContent(contentElement)

  // Add tooltip content to template
  try {
    tooltipTemplate.firstElementChild.append(content)
  } catch (error) {
    tooltipTemplate.firstChild.append(content)
  }

  el.parentNode.insertBefore(tooltipTemplate, contentElement)

  content.hidden = false;
  el.classList.add('tooltip')
}

function getTooltipContent(content) {
  return content.cloneNode(true)
}

function removeTooltip(el) {
  el.removeAttribute('data-tooltip')
  el.removeEventListener('mouseover', mouseoverTooltip)
}

function mouseoverTooltip(e) {
  var target = e.target.closest('[data-tooltip]')
  if (target) {
    addTooltip(target, target.nextElementSibling)
    removeTooltip(target)
  }
}

function init() {
  var list = document.querySelectorAll('[data-tooltip]')
  Array.from(list).forEach(function(itm) { itm.addEventListener('mouseover', mouseoverTooltip)})
}

document.addEventListener('DOMContentLoaded', init);

module.exports.reInit = init;